import { Type } from '@angular/core';
import { MenuHeaderSproutComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-sprout/menu-header-sprout.component';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { PrintMenu } from '../print-menu';
import { PrintHeaderLayoutType } from '../../enum/shared/print-header-layout-type.enum';
import { PrintFooterLayoutType } from '../../enum/shared/print-footer-layout-type.enum';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnCannabinoidType } from '../../enum/shared/section-column-cannabinoid-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class SproutMenu extends PrintMenu {
  getPageBottomMargin(): string {
    return '0.5in';
  }

  getPageTopMargin(): string {
    return '0.5in';
  }

  getPageLeftMargin(): string {
    return '0.5in';
  }

  getPageRightMargin(): string {
    return '0.5in';
  }

  getThemeClass(): string {
    return 'sprout-theme';
  }

  getPrintHeaderLayoutType(): PrintHeaderLayoutType {
    return this.menuOptions?.printHeaderLayout || PrintHeaderLayoutType.AllPages;
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderSproutComponent;
  }

  getPrintFooterLayoutType(): PrintFooterLayoutType {
    return this.menuOptions?.printFooterLayout || PrintFooterLayoutType.None;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getShowSectionHeaderColorAsIcon(): boolean {
    return true;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.AcuminProWide.Bold_700, FONT.AcuminProWide.SemiBold_600, FONT.AcuminProWide.Regular_400];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/rge3uef.css';
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.ProductTitle, 0],
      [SectionColumnProductInfoType.Brand, 1],
      [SectionColumnProductInfoType.Strain, 2],
      [SectionColumnProductInfoType.StrainType, 3],
      [SectionColumnProductInfoType.Badge, 4],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(5),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(6),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(7, false),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(8),
      [SectionColumnProductInfoType.QuantityAndSize, 9],
      [SectionColumnProductInfoType.Quantity, 10],
      [SectionColumnProductInfoType.Size, 11],
      [SectionColumnProductInfoType.VariantType, 12],
      [SectionColumnProductInfoType.Stock, 13],
      [SectionColumnCannabinoidType.THCAndCBD, 14],
      [SectionColumnProductInfoType.GradingResults, 15],
      [SectionColumnProductInfoType.VariantPrice, 16],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 17]
    ]);
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }
}
